import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { filter, takeUntil } from 'rxjs/operators';
import { LoginService } from '@boxx/login-core/lib/services/login.service';
import { LoginStore } from '@boxx/login-core/lib/state/login.store';
import { OnboardingStore } from '@boxx/onboarding-core/lib/state/onboarding.store';
import { BRANDING_LS_KEY, DynamicBrandingService } from '@boxx/dynamic-branding/lib/services/dynamic-branding-service';
import { OnboardingService } from '@boxx/onboarding-core/lib/services/onboarding.service';
import { ActionSheetController, LoadingController, ModalController, Platform } from '@ionic/angular';
import { Browser } from '@capacitor/browser';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { AVAILABLE_LANGUAGES, SELECTED_LANGUAGE_LS_KEY } from 'src/services/translate/languagesData';
import { BottomSheetType } from '@app/components/bottom-sheet/bottom-sheet.model';
import { TranslateConfigService } from 'src/services/translate/translate-config.service';
import { SharingService } from 'src/services/NativeSharing.service';
import { APP_CONSTANTS } from 'src/constants/constants';
import { environment } from 'src/environments/environment.prod';
import { BusinessFacade } from '@app/pages/home/state/facades/business.facade';
import { DeleteAccountPage } from '../components/delete-account/delete-account.page';

@Component({
  selector: 'app-options-support',
  templateUrl: './options-support.page.html',
  styleUrls: ['./options-support.page.scss'],
})
export class OptionsSupportPage implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  destroyed$ = new Subject<boolean>();
  translations: any;

  isPwaView = false;
  selectedItem: number | null;
  breakpointWidth: number;
  accountItemSelected = 0;
  defaultImage: string = 'assets/icon/LateralMenu_ProfileIcon.svg';
  logoUrl: string;
  userName: string;
  businessName: string;
  step = 1;
  businessEmail: string;
  maskEmail: string;
  codeUser: string;
  pass: string;
  confirmPass: string;
  isPassReveal = false;
  isConfirmPassReveal = false;

  optionSelected: number;
  itemSelected = '1';
  buttonText: string;
  supportUrl: string;
  optionsupport: string;
  supportEmail: string;
  faqs: Array<{ title: string; description: string }> = [];
  brandName: string;

  termsData: any;
  privacyData: any;

  filterType = 'PRIVACY';
  loader: any;
  isLoading = false;
  currentLng: string;

  passwordHasLetters = false;
  passwordHasMinLengt = false;
  passwordHasDigitsOrSpecial = false;
  passwordMeetsReqs = false;
  passwordStrength: 'WEAK' | 'MEDIUM' | 'STRONG' | 'UNSET' = 'UNSET';

  constructor(public translate: TranslateService,
    private boxxUtils: BoxxUtilsService,
    private router: Router,
    private authSrvc: LoginService,
    public loginStore: LoginStore,
    private storeBusiness: OnboardingStore,
    private dBrandingService: DynamicBrandingService,
    private onboardingService: OnboardingService,
    private storageService: LocalStorageNativeService,
    private translateConfig: TranslateConfigService,
    private modalCtrl: ModalController,
    private platform: Platform,
    private sharingSrvc: SharingService,
    private actionSheetCtrl: ActionSheetController,
    private loadingCtrl: LoadingController,
    private busineesFacade: BusinessFacade
  ) {

    translate.get(['EVENTS_MODULE', 'STORE_MODULE', 'SUPPORT_VIEW', 'FOOD_MODULE', 'ACTIONS', 'SIDEMENU', 'ERRORS', 'SUCCESS', 'FAQS_VIEW'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => {
        this.optionsupport = this.dBrandingService.optionSupport;
        this.supportEmail = this.dBrandingService.supportEmail;
        this.supportUrl = this.dBrandingService.supportUrl;

        this.translations = t;
        if (this.supportUrl && this.supportUrl !== null && this.supportUrl !== undefined && this.supportUrl !== '') {
          this.buttonText = this.translations.SUPPORT_VIEW.buttonTicketText.toUpperCase();
          //return;
        }
        else {
          this.buttonText = (this.optionsupport === 'both') ? (this.translations.SUPPORT_VIEW.buttonText).toUpperCase() : ((this.optionsupport === 'email') ? (this.translations.SUPPORT_VIEW.emailText).toUpperCase() : (this.translations.SUPPORT_VIEW.buttonTicketText).toUpperCase());
        }

        const appName = dBrandingService.tradename;
        if (dBrandingService.useSpecialFaqs(dBrandingService.tradename.toUpperCase())) {
          this.faqs = t.FAQS_VIEW.faqsPWA;
        }
        else {
          this.faqs = t.FAQS_VIEW.faqs;
        }

        this.faqs = this.faqs.map(faq => ({
          title: faq.title.replace(/{{appName}}/g, appName),
          description: faq.description.replace(/{{appName}}/g, appName),
        }));

      });
  }

  ngOnInit() {
    this.selectedItem = null;
    this.getLanguage();
    //this.listenThemeChanges();
  }

  async getLanguage(){
    const language = await this.storageService.getItem('selectedLanguage');
    this.currentLng = language;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

    onPassChange(pass: any) {
      let val = pass.target.value;
      this.passwordHasLetters = new RegExp(/[a-z]+[A-Z]|[A-Z]+[a-z]+/).test(val.toString());
      this.passwordHasMinLengt = val.toString().length > 7;
      this.passwordHasDigitsOrSpecial = new RegExp(APP_CONSTANTS.PASSWORD_PATTERN).test(
        val.toString()
      );
  
      this.passwordMeetsReqs =
        this.passwordHasLetters && this.passwordHasMinLengt && this.passwordHasDigitsOrSpecial;
  
      if (this.passwordMeetsReqs) {
        const specialCharsCount = val.toString().match(APP_CONSTANTS.PASSWORD_PATTERN).length;
  
        const countNumbers = (val.toString().replace(/\D/g, '').length);
        const countSpecialC = (val.toString().match(/\W|_/g) || []).length;
  
        this.passwordStrength = 'WEAK';
  
        if ((countNumbers === 1 && countSpecialC === 1) || (countNumbers === 0 && countSpecialC > 0) || (countNumbers > 0 && countSpecialC === 0)) {
          this.passwordStrength = 'MEDIUM';
        } else if ((countNumbers > 1 && countSpecialC === 1) || (countNumbers === 1 && countSpecialC > 1) || (countNumbers > 1 && countSpecialC > 1)) {
          this.passwordStrength = 'STRONG';
        }
      }
    }

  getTranslatePasswordStrength(passwordStrength) {
    return 'ONBOARDING_MODULE.USER_INFO_VIEW.passwordStrength.' + passwordStrength;
  }

  async listenThemeChanges() {
    this.boxxUtils.handleLoading(true);
    const storedBranding = await this.storageService.getItem(BRANDING_LS_KEY);
    const parseBrandData = JSON.parse(storedBranding);
    let appKey = this.dBrandingService.getBrandKey(parseBrandData.tradename.toUpperCase());

    this.authSrvc.getThemeData(environment.appThemeKey).subscribe(async dataBrand => {
      if (dataBrand) {
        let _db = dataBrand;
        console.log('dataBrand: ', _db);
        if ((dataBrand.support_email !== undefined) && (dataBrand.support_url !== undefined)) {
          this.optionsupport = 'both';
        }
        else if ((dataBrand.support_email === undefined) && (dataBrand.support_url !== undefined)) {
          this.optionsupport = 'url';
        }
        else if ((dataBrand.support_email !== undefined) && (dataBrand.support_url === undefined)) {
          this.optionsupport = 'email';
        }
      }
      this.boxxUtils.handleLoading(false);
    },
      (err) => {
        this.boxxUtils.handleLoading(false);
      });
  }

  ionViewDidEnter() {
    this.step = 1;
  }

  ionViewWillEnter() {

 this.subscriptions.add(this.busineesFacade.business$
      .pipe(
        filter(business => business != null)
      ).subscribe((business: any) => {
        if (business && business !== undefined) {
          console.log('business data: ', business);

          this.businessEmail = (business.emailUser !== undefined && business.emailUser !== null) ? business.emailUser : '';
          if (this.businessEmail !== '') {
            const emailFull = this.businessEmail.split('@');
            this.maskEmail = emailFull[0][0] + '*****@' + emailFull[1];
          }
          this.logoUrl = business.images?.logo_image?.content;
          this.userName = business.name;
          this.businessName = business.businessName;
  
          if (this.optionSelected === 2) {
            console.log('buscando brand:', business);
            this.validaLegalDocuments(Number(business.brand_id));
          }
          else if (this.optionSelected === 3) {
            const _languages = AVAILABLE_LANGUAGES;
            console.log('_languages: ', _languages);
          }

        }
      }));

    // this.storeBusiness.businessConfig.businessData$
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe((business) => {
    //     if (!business) {
    //       return;
    //     }

    //     this.businessEmail = (business.emailUser !== undefined && business.emailUser !== null) ? business.emailUser : '';
    //     if (this.businessEmail !== '') {
    //       const emailFull = this.businessEmail.split('@');
    //       this.maskEmail = emailFull[0][0] + '*****@' + emailFull[1];
    //     }
    //     this.logoUrl = business.images?.logo_image?.content;
    //     this.userName = business.name;
    //     this.businessName = business.businessName;

    //     if (this.optionSelected === 2) {
    //       console.log('buscando brand:', business);
    //       this.validaLegalDocuments(Number(business.brand_id));
    //     }
    //     else if (this.optionSelected === 3) {
    //       const _languages = AVAILABLE_LANGUAGES;
    //       console.log('_languages: ', _languages);
    //     }


    //   });

    this.brandName = this.dBrandingService.getCurrentBrandName().toUpperCase();
  }

  async validaLegalDocuments(brand_id: number) {
    const language = await this.storageService.getItem('selectedLanguage');
    this.isLoading = true;
    this.onboardingService.getLawDocuments(environment.brand_id, language, 'terms').subscribe(
      (data) => {
        console.log('terms ', data);
        if (data && data.attributes !== undefined) {
          this.termsData = data.attributes.body;
        }
      },
      (error) => {
        this.isLoading = false;
      }
    );
    this.onboardingService.getLawDocuments(environment.brand_id, language, 'policy').subscribe(
      (data) => {
        console.log('policy: ', data);
        if (data && data.attributes !== undefined) {
          this.privacyData = data.attributes.body;
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  openPage(page: number) {
    this.selectedItem = page;
  }

  openAction(action: number) {

  }

  setOptionSegment(option: string) {
    this.itemSelected = option;
  }

  close() {
    this.modalCtrl.dismiss();
  }

  filterBy(criteria: string) {
    this.filterType = criteria;
  }

  async deleteAccount() {
    const _emailForm = this.businessEmail;
        const modal = await this.modalCtrl.create({
          component: DeleteAccountPage,
          componentProps: {
            _previousEmail: _emailForm
          }
        });
    
        modal.present();
    
        const { data } = await modal.onDidDismiss();

    // this.boxxUtils.showAlert({
    //   header: this.translations.SIDEMENU.DELETE_ACCOUNT_ALERT.header,
    //   message: this.translations.SIDEMENU.DELETE_ACCOUNT_ALERT.message,
    //   animated: true,
    //   buttons: [
    //     {
    //       text: this.translations.ACTIONS.delete,
    //       role: 'destructive',
    //       handler: () => {
    //         this.boxxUtils.handleLoading(true);
    //         this.authSrvc
    //           .deleteAccount()
    //           .then(async (resp: any) => {
    //             this.boxxUtils.handleLoading(false);
    //             this.boxxUtils.showToastSuccess({
    //               message: this.translations.SIDEMENU.MESSAGES.success,
    //             });
    //             await this.router.navigateByUrl('/login');
    //           })
    //           .catch((error) => {
    //             this.boxxUtils.showToastSuccess({
    //               message: this.translations.SIDEMENU.MESSAGES.error,
    //             });
    //             this.boxxUtils.handleLoading(false);
    //           });
    //       },
    //     },
    //     {
    //       text: this.translations.ACTIONS.cancel,
    //       cssClass: 'boxx-main-btn',
    //     },
    //   ],
    // });
  }

  openAccountItem(item: number) {
    // if(item === 2){
    //   return;
    // }
    this.accountItemSelected = item;

    if (item === 1) {
      this.step = 1;
      //this.rensendCode();
    }
  }

  resendCode() {
    this.boxxUtils.handleLoading(true);
    this.onboardingService.sendPasswordCode({ email: this.businessEmail })
      .subscribe((data) => {
        this.boxxUtils.handleLoading(false);
      },
        (error) => {
          this.boxxUtils.handleLoading(false);
        });
  }

  async doLogout() {
    this.boxxUtils.showAlert({
      header: this.translations.SIDEMENU.LOGOUT_ALERT.header,
      message: this.translations.SIDEMENU.LOGOUT_ALERT.message,
      buttons: [
        {
          text: this.translations.ACTIONS.ok,
          role: 'destructive',
          handler: () => {
            this.loginStore.logout();
            this.modalCtrl.dismiss();
            this.router.navigateByUrl('welcome');
          },
        },
        {
          text: this.translations.ACTIONS.cancel,
          cssClass: 'boxx-main-btn',
        },
      ],
    });
  }

  validateCode() {
    // this.step = 2;
    // return;
    this.boxxUtils.handleLoading(true);
    this.onboardingService.validatePasswordCode({ email: this.businessEmail, verification_code: this.codeUser })
      .subscribe((data) => {
        this.codeUser = '';
        this.boxxUtils.handleLoading(false);
        this.step = 2;
      },
        (error) => {
          this.boxxUtils.showToastError({
            message: this.translations.SUPPORT_VIEW.PASSWORD_UPDATE.errorCode
          });
          this.boxxUtils.handleLoading(false);
        });
  }

  success(){
    this.modalCtrl.dismiss();
  }

  updatePass() {
    // this.step = 3;
    // //this.accountItemSelected = 0;
    // return;
    this.boxxUtils.handleLoading(true);
    this.onboardingService.updatePassword({ email: this.businessEmail, password: this.pass, confirm_password: this.confirmPass })
      .subscribe((data) => {
        this.pass = '';
        this.confirmPass = '';
        // this.boxxUtils.showToastSuccess({
        //   message: this.translations.SUPPORT_VIEW.PASSWORD_UPDATE.successPassword
        // });
        this.boxxUtils.handleLoading(false);
        this.step = 3;
        //this.accountItemSelected = 0;
      },
        (error) => {
          this.boxxUtils.showToastError({
            message: this.translations.SUPPORT_VIEW.PASSWORD_UPDATE.errorCode
          });
          this.boxxUtils.handleLoading(false);
        });
  }

  closeAccountItem() {
    this.accountItemSelected = 0;
  }

  async openPrivacy() {
    const _url = ((this.dBrandingService.privacyUrl && this.dBrandingService.privacyUrl !== '#') ? this.dBrandingService.privacyUrl : 'https://myboxx.app/aviso-de-privacidad/');
    await Browser.open({ url: _url, toolbarColor: 'primary', presentationStyle: 'fullscreen' });
  }

  async openTos() {
    const _url = ((this.dBrandingService.termsUrl && this.dBrandingService.termsUrl !== '#') ? this.dBrandingService.termsUrl : 'https://myboxx.app/terms-user-boxx/');
    await Browser.open({ url: _url, toolbarColor: 'primary', presentationStyle: 'fullscreen' });
  }

  revealPass() {
    this.isPassReveal = !this.isPassReveal;
  }

  revealConfirmPass() {
    this.isConfirmPassReveal = !this.isConfirmPassReveal;
  }

  backOption() {
    this.accountItemSelected = 0;
  }

  async pickerLanguage() {
    console.log('this.currentLng ', this.currentLng);
    this.boxxUtils.openBottomSheet({
      data: [],
      firstTimeOpen: true,
      type: BottomSheetType.languages,
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      canClose: true,
      title: '',
      maxHeigth: 25,
      previousValue: this.currentLng
    }).then((data) => {
      if (data?.value) {
        const _lng: any = data?.value;
        this.translateConfig.setLanguage(_lng.key);
        this.storageService.setItem(SELECTED_LANGUAGE_LS_KEY, _lng.key);
        this.currentLng = _lng.key;
      }
    });

  }

  async requestSupport() {
    console.log('this.optionsupport: ', this.optionsupport);
    console.log('this.supportUrl: ', this.supportUrl);
    console.log('this.supportEmail: ', this.supportEmail);

    // if (this.supportUrl && this.supportUrl !== null && this.supportUrl !== undefined && this.supportUrl !== '') {
    //   if (this.platform.is('android') || this.platform.is('ios')) {
    //     this.sharingSrvc.openURL(this.supportUrl);
    //   }
    //   else { //Es web
    //     this.sharingSrvc.openExternalURL(this.supportUrl);
    //   }
    //   return;
    // }

    if (this.optionsupport === 'both') {
      (
        await this.actionSheetCtrl.create({
          header: this.translations.SUPPORT_VIEW.header_Alert,
          buttons: [
            {
              text: this.translations.SUPPORT_VIEW.emailText,
              handler: () => {
                this.sendEmail();
              },
              icon: 'mail-outline'
            },
            {
              text: this.translations.SUPPORT_VIEW.urlText,
              handler: async () => {
                if (this.platform.is('android') || this.platform.is('ios')) {
                 // this.sharingSrvc.openURL(this.supportUrl);
                  await Browser.open({
                    url: this.supportUrl,
                    windowName: '_blank' 
                  });
                }
                else { //Es web
                  await Browser.open({
                    url: this.supportUrl,
                    windowName: '_blank' 
                  });
                  //this.sharingSrvc.openExternalURL(this.supportUrl);
                }
              },
              icon: 'settings-outline'
            },
            {
              text: this.translations.ACTIONS.cancel,
              role: 'cancel',
              icon: 'close-circle-outline'
            },
          ],
        })
      ).present();
    }
    else if (this.optionsupport === 'url') {
      await Browser.open({
        url: this.supportUrl,
        windowName: '_blank' 
      });
      //this.sharingSrvc.openExternalURL(this.supportUrl);
    }
    else if (this.optionsupport === 'email') {
      this.sendEmail();
    }
  }

  async sendEmail() {
    window.open('mailto:' + this.supportEmail, '_system');

// console.log('this.supportEmail: ', this.supportEmail);
// return;
    // await Browser.open({
    //   url: 'mailto:' + this.supportEmail,
    //   windowName: '_system' 
    // });
   
    //const session = await this.authSrvc.getSession();

    // this.loader = await this.loadingCtrl.create();
    // await this.loader.present();

    // this.storeBusiness.businessConfig.businessData$
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe(async businessData => {
    //     // if (!businessData.siteUrl) {
    //     //   console.log('aqui entra');
    //     //   return;
    //     // }

    //     const deviceInfo = {
    //       manufacturer: '',
    //       model: '',
    //       osName: '',
    //       version: '',
    //     };

    //     const appInfo = {
    //       version: '',
    //       buildNumber: '',
    //     };

    //     if (this.isCordovaOrCapacitor) {
    //       const _info = await Device.getInfo();
    //       const _appData = await App.getInfo();

    //       deviceInfo.manufacturer = _info.manufacturer;
    //       deviceInfo.model = _info.model;
    //       deviceInfo.osName = _info.platform;
    //       //deviceInfo.version = _info.iOSVersion.toString();

    //       try {
    //         appInfo.version = _appData.build;
    //         appInfo.buildNumber = _appData.version;
    //       } catch (error) { }

    //     } else {
    //       deviceInfo.manufacturer = window.navigator.vendor;
    //       deviceInfo.model = window.navigator.userAgent;
    //       deviceInfo.osName = window.navigator.platform;
    //       //deviceInfo.version = window.navigator.appVersion;

    //       appInfo.version = 'PWA';
    //       appInfo.buildNumber = APP_CONSTANTS.PWA_VERSION;
    //     }

    //     const addNewLine = (text: string) => {
    //       if (this.isCordovaOrCapacitor) {
    //         return '\n';
    //       }

    //       const BLACK_LIST = ['ELE-L29', 'LG-H500'];
    //       const newLine =
    //         BLACK_LIST.indexOf(deviceInfo.model.toUpperCase()) !== -1 ? '</br>' : '\n';
    //       return encodeURIComponent(`${newLine}${text}`);
    //     };

    //     const subject = `?subject=Support ${this.dBrandingService.tradename}&body=`;
    //     const container = `${this.supportEmail}`;
    //     const separator = addNewLine('-- SUPPORT REQUEST --');
    //     const userEmail = addNewLine('User email: ' + this.supportEmail);
    //     const siteUrl = addNewLine('Site url: ' + (businessData.siteUrl) ? businessData.siteUrl : '');
    //     const appVersion = addNewLine(
    //       `App Version: ${appInfo.version} build: ${appInfo.buildNumber}`
    //     );
    //     const manufacturer = addNewLine(`Manufacturer: ${deviceInfo.manufacturer}`);
    //     const model = addNewLine(`Model: ${deviceInfo.model}`);
    //     const osName = addNewLine(`OS Name:  ${deviceInfo.osName}`);
    //     const osVersion = addNewLine(`OS Version: ${deviceInfo.version}`);
    //     let body = '';

    //     const isApp = document.URL.indexOf('http') !== 0;
    //     if (isApp) {
    //       if (siteUrl) {
    //         body = separator + userEmail + siteUrl + appVersion + manufacturer + model + osName + osVersion;
    //       }
    //       else {
    //         body = separator + userEmail + appVersion + manufacturer + model + osName + osVersion;
    //       }
    //     }
    //     else {
    //       body = '-- SUPPORT REQUEST --' + '%0D%0A' + 'User email: ' + this.supportEmail + "%0D%0A" + 'App Version: ' + appInfo.version + "%0D%0A" + 'Model: ' + deviceInfo.model + "%0D%0A" + 'OS Name: ' + deviceInfo.osName + "%0D%0A" + 'OS Version: ' + deviceInfo.version;
    //     }

    //     const url = container + subject + body;

    //     // await this.loadingCtrl.dismiss();

    //     window.open('mailto:' + url, '_blank');


        // await Browser.open({
        //   url: 'mailto:' + url,
        //   windowName: '_system' 
        // });

      //});
  }

}
